/*eslint-disable*/
export default {
    data () {
        return {
            isDown: false,
            startX: 0,
            scrollLeft: 0,
            gameBoxName: "",
        }
    },
    methods: {
        handleScroll (e) {
            const selector = '.shutter__container_interactive-place_main-box_row';
            const rowChildWidth = document.querySelector(selector).firstElementChild.offsetWidth;
            if (rowChildWidth <= document.querySelector('.play-box').clientWidth) {
                return;
            }
            e = window.event || e;
            let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
            document.querySelector(`.${this.gameBoxName}`).scrollLeft -= (delta * 65);
            e.preventDefault();
        },
        handleMouseDown (event) {
            this.isDown = true;
            this.startX = event.pageX - event.target.offsetLeft;
            this.scrollLeft = event.target.scrollLeft;
        },
        handleMouseMove (event) {
            if (!this.isDown) {
                return;
            }
            event.preventDefault();
            const x = event.pageX - event.target.offsetLeft;
            const walk = (x - this.startX) * 3;
            document.querySelector(`.${this.gameBoxName}`).scrollLeft = this.scrollLeft - walk;
        },
    }
}
